import React from 'react';
import PropTypes from 'prop-types';
import { Wrapper, Button, Menu, MenuItem } from 'react-aria-menubutton';

const ProjectStore = require('../../stores/ProjectStore');

const propTypes = {
    id: PropTypes.string,
    selectedProjectId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    className: PropTypes.string,
    onProjectChange: PropTypes.func.isRequired,
    channelId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    rejectProjectIds: PropTypes.arrayOf(PropTypes.number)
};

const defaultProps = {
    id: 'project-role-select',
    selectedProjectId: 0,
    className: '',
    channelId: 0,
    rejectProjectIds: []
};

class ProjectDropdown extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            projectStoreState: ProjectStore.getState()
        };

        this.unsubscribes = [
            ProjectStore.listen(this.onStoreChange.bind(this, 'projectStoreState')),
        ];
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(unsubscribeCallback => { unsubscribeCallback(); });
    }

    onStoreChange(storeStateName, state) {
        this.setState({ [storeStateName]: state });
    }

    render() {
        const self = this;
        let triggerContent = 'Select a project...';
        let projects = [];

        if (this.state.projectStoreState.initialized) {
            if (!this.props.channelId) {
                projects = this.state.projectStoreState.projects;
            }
            else {
                projects = this.state.projectStoreState.projects.filter(p => p.channelId === parseInt(this.props.channelId));
            }

            if (this.props.rejectProjectIds) {
                projects = projects.filter(p => this.props.rejectProjectIds.indexOf(p.id) < 0);
            }
        }

        const menuItems = projects.map(project => {
            let itemClass = 'AriaMenuButton-menuItem';
            if (parseInt(self.props.selectedProjectId, 10) === project.id) {
                itemClass += ' is-selected';
                triggerContent = project.name;
            }

            return (
                <li className='AriaMenuButton-menuItemWrapper' key={project.id}>
                    <MenuItem
                        className={itemClass}
                        value={project.id}
                        text={project.name}
                    >
                        {project.name}
                    </MenuItem>
                </li>
            );
        });

        if (menuItems.length === 0) {
            menuItems.push(
                <li className='AriaMenuButton-menuItemWrapper' key="-1">
                    <MenuItem
                        className="font-style-italic is-selected"
                        value="-1"
                        text="No available projects"
                    >
                        No available projects
                    </MenuItem>
                </li>
            )
        }

        return (
            <Wrapper
            id={this.props.id}
            className={`AriaMenuButton ${this.props.className}`}
            onSelection={this.props.onProjectChange}>
                <Button className='AriaMenuButton-trigger'>
                    {triggerContent}
                </Button>
                <Menu>
                    <ul className='AriaMenuButton-menu'>
                        {menuItems}
                    </ul>
                </Menu>
            </Wrapper>
        );
    }
}

ProjectDropdown.propTypes = propTypes;
ProjectDropdown.defaultProps = defaultProps;

export default ProjectDropdown;